module.exports = __webpack_public_path__ + "static/media/uber.37baf354.png";